import { createContext, useContext } from "react"

const PanelIdContext = createContext<string | undefined>(undefined)
const PanelTitleContext = createContext<string | undefined>(undefined)

export const PanelIdProvider = PanelIdContext.Provider
export const PanelTitleProvider = PanelTitleContext.Provider

/**
 * Returns the current panel ID when rendered inside a dashboard panel (Dockview).
 * Returns undefined when outside dashboard context (e.g. Compare page).
 */
export function usePanelId(): string | undefined {
  return useContext(PanelIdContext)
}

/**
 * Returns the current panel title when rendered inside a dashboard panel (Dockview).
 * Returns undefined when outside dashboard context (e.g. Compare page).
 */
export function usePanelTitle(): string | undefined {
  return useContext(PanelTitleContext)
}
